export default __webpack_public_path__ + "assets/images/Hotmelt_8b54d982dfbc3ff729ce466c37c87826.jpg";